import script from "./houseDetailManage.vue?vue&type=script&setup=true&lang=js"
export * from "./houseDetailManage.vue?vue&type=script&setup=true&lang=js"

import "./houseDetailManage.vue?vue&type=style&index=0&id=6c6ad264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6ad264"]])

export default __exports__